import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { store } from './store.js';
import "./i18n";

// The outermost boundary (P26): the last line of defence if something above
// the router throws — a provider, the layout shell, App itself. App.jsx holds a
// second one inside the router that resets on navigation.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <div data-testid="app-root">
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </div>
    </Provider>
  </StrictMode>
);
